module.exports = __webpack_public_path__ + "img/IDCard.054b7cb9.png";